const buildActionType = (actionType, status = '') => {
  if (typeof actionType === 'string') {
    return `${actionType}${status}`;
  }
  return `${actionType.entity}${actionType.action}${status}`;
};

export { buildActionType };
